import React, { useMemo, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSortBy } from 'react-instantsearch';
import { SearchBar } from '@uncinc/react-searchkit';
import type { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import SearchBarButton from '../../Button/SearchBarButton';
import SearchResetButton from '../../Button/SearchResetButton';

import {
  SCREEN_TABLET,
  APP_OPTIONS,
  INFOLEP_HOSTS,
  INFOLEP_DOMAIN,
  INFONTD_DOMAIN,
} from '../../../config/constants';

import '../../SearchGeneral/Styles/_searchbar.scss';

const SearchAllContentSearchBar: React.FC<SearchBarProps> = (props) => {
  const { className, onSubmit, ...restProps } = props;
  const ref = useRef();

  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isMobile = useMemo(() => width < SCREEN_TABLET, [width]);
  const currentDomain = INFOLEP_HOSTS.includes(window.location.host)
    ? INFOLEP_DOMAIN
    : INFONTD_DOMAIN;

  const sortValueScore = APP_OPTIONS.parameters.searchkitIndexAllContent;
  const sortValueYear = `${APP_OPTIONS.parameters.searchkitIndexAllContent}_bibcite_year`;

  const {
    currentRefinement,
    refine,
  } = useSortBy({
    items: [
      {
        label: t('components.search_all_content.sort_by.items.score'),
        value: sortValueScore,
      },
      {
        label: t('components.search_all_content.sort_by.items.bibcite_year'),
        value: sortValueYear,
      },
    ],
  });

  const classNames = c('SearchAllContent__SearchBar', className);
  const searchBarPlaceholder = t(`components.search_all_content.search_bar.${currentDomain}.placeholder`);
  const searchBarMobilePlaceholder = t('components.search_all_content.search_bar.placeholder_mobile');

  return (
    <SearchBar
      {...restProps}
      className={classNames}
      placeholder={isMobile ? searchBarMobilePlaceholder : searchBarPlaceholder}
      button={SearchBarButton}
      showReset
      ref={ref}
      resetProps={{
        button: SearchResetButton,
      }}
      onSubmit={(query) => {
        // If our query is empty make sure we sort by year.
        if (!query && currentRefinement !== sortValueYear) {
          refine(sortValueYear);
        }
        // If we have a query then make sure the score sorting is activated.
        if (query && currentRefinement !== sortValueScore) {
          refine(sortValueScore);
        }
        // Call the passed onSubmit, if we have it.
        if (onSubmit) {
          onSubmit(query);
        }

        // Unblur the focus on submit.
        if (ref.current) {
          // @ts-ignore
          ref.current.blur();
        }
      }}
    />
  );
};

export default SearchAllContentSearchBar;
